import axios from "axios";
import { DELETE_COMMENTS, UPDATE_COMMENTS } from "actions/ActionTypes";
import { delApi, postApi } from "actions/SendActions";
import rootURL from "utils/RootURL";
import { formatHeaders } from "utils/Api";

export const fetchComment = (token, projectSlug, uuid, callback) => {
  axios({
    url: rootURL(`/api/user/v3/admin/comment/${uuid}`),
    method: "GET",
    headers: formatHeaders(token, [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ]),
  }).then((resp) => {
    if (resp?.data) callback(resp.data);
  });
};

export const deleteComments = (
  comments,
  token,
  projectSlug,
  t,
  length,
  callback,
) => {
  const commentsLength = length > 1 ? "_plural" : "";
  return delApi({
    endpoint: `/api/user/v3/admin/comments/delete`,
    type: DELETE_COMMENTS,
    item: "comments",
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    token,
    data: {
      uuids: comments,
    },
    message: t(`editor-notif:deleteSuccess${commentsLength}`),
    error: t(`editor-notif:deleteError`),
    callback,
  });
};

export const validateComments = (
  comments,
  token,
  projectSlug,
  t,
  length,
  callback,
) => {
  const commentsLength = length > 1 ? "_plural" : "";

  return postApi({
    endpoint: `/api/user/v3/admin/comments/validate`,
    type: UPDATE_COMMENTS,
    item: "comments",
    headers: [
      {
        key: "xx-ok-project",
        value: projectSlug,
      },
    ],
    token,
    data: {
      uuids: comments,
    },
    message: t(`editor-notif:validateSuccess${commentsLength}`),
    error: t(`editor-notif:validateError`),
    callback,
  });
};
